





































































import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { IRefSuggestion } from "@/store/modules/fleet-aggregation.store";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import RefsSelected from "./RefsSelected.vue";
import RefsSelection from "./RefsSelection.vue";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { IPageFilterElement } from "@/models/page-filter-element.entity";

@Component({
  components: { RefsSelected, RefsSelection },
  filters: {}
})
export default class RefsSelect extends Vue {
  @Prop()
  private value!: MrfiktivReferenceGen[];

  @Prop({ default: false })
  hideSuggestions!: boolean;

  @Prop()
  buttonLabel?: string;

  @Prop({ default: () => [] })
  filters!: IPageFilterElement[];

  get selected(): MrfiktivReferenceGen[] {
    return this.value;
  }
  set selected(v: MrfiktivReferenceGen[]) {
    this.$emit("input", v);
    this.emitChange();
  }

  @Prop({ default: () => [] })
  suggested!: IRefSuggestion[];

  @Prop()
  partnerId!: string;

  @Prop({ default: false })
  isConfirmable!: boolean;

  @Prop({
    default: () => [
      BackendResourceEnum.VEHICLE,
      BackendResourceEnum.EVENT,
      BackendResourceEnum.REPORT,
      BackendResourceEnum.TICKET,
      BackendResourceEnum.DOCUMENT,
      BackendResourceEnum.SIGN,
      BackendResourceEnum.COST,
      BackendResourceEnum.CLEARANCE,
      BackendResourceEnum.CLEARANCE_APPROVAL,
      BackendResourceEnum.FLEET
    ]
  })
  categories!: BackendResourceEnum[];

  /**
   * if this is set to true the list with suggestions and page items will always be shown, not just the items that are already selected.
   * e.g. used in create ticket stepper
   */
  @Prop({ default: false })
  listMode!: boolean;

  @Prop({ default: false })
  hideEditButton!: boolean;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: true })
  scroll!: boolean;

  readonly SCROLL_MARKER_ID = "refs-select-scroller";

  readonly BackendResourceEnum = BackendResourceEnum;

  readonly SUGGESTION = "suggestion";

  readonly RefTypeMap = RefTypeMap;

  isMenu = false;

  isEdit = this.listMode;

  searchFilter = "";

  isLoading = false;

  isLoadingAll = false;

  selectedCategory = this.suggested.length ? this.SUGGESTION : this.categories[0];

  get btnText() {
    return this.buttonLabel ?? this.$t("refs.addReference");
  }

  get openDetail() {
    if (this.$listeners.openDetail) {
      return this.$listeners.openDetail;
    }

    return undefined;
  }

  scrollToEnd() {
    if (!this.scroll) {
      return;
    }
    const end = document.getElementById(this.SCROLL_MARKER_ID);
    end?.scrollIntoView({ behavior: "smooth" });
  }

  async clickEdit() {
    this.$log.debug("clickEdit");
    this.isEdit = !this.isEdit;
    this.$emit("click");
  }

  emitChange() {
    this.$emit("change", this.selected);
  }

  open() {
    this.isMenu = true;
  }
}
